export default "__VITE_ASSET__DGj56fvL__"